module.exports = new __parcel__URL__("avocado.8855629b.svg").toString();